import { useEffect, useRef, useState } from 'react';

// Número que "conta" do valor anterior até o novo (count-up), com easeOutCubic.
// Usado nos KPIs do dashboard pra dar dinamismo. `format` recebe o número
// intermediário e devolve a string exibida (ex.: formatação BRL).
export default function AnimatedNumber({ value = 0, duration = 1100, format = v => v }) {
  const [display, setDisplay] = useState(value);
  const fromRef = useRef(0);

  useEffect(() => {
    const from = fromRef.current;
    const to = Number(value) || 0;
    if (from === to) { setDisplay(to); return; }
    let raf;
    let t0 = null;
    const tick = (now) => {
      if (t0 === null) t0 = now;
      const p = Math.min((now - t0) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setDisplay(from + (to - from) * eased);
      if (p < 1) raf = requestAnimationFrame(tick);
      else fromRef.current = to;
    };
    raf = requestAnimationFrame(tick);
    return () => { if (raf) cancelAnimationFrame(raf); };
  }, [value, duration]);

  return <>{format(display)}</>;
}
